import React, { useState } from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Paper,
  Divider,
  List,
  ListItem,
  ListItemText,
  Tabs,
  Tab
} from '@mui/material';

const Privacy = () => {
  const [language, setLanguage] = useState('cn'); // 'cn' for Chinese, 'en' for English
  
  const handleLanguageChange = (event, newValue) => {
    setLanguage(newValue);
  };
  
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper elevation={2} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h4" gutterBottom align="center">
          隐私政策 / Privacy Policy
        </Typography>
        
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 4 }}>
          <Tabs value={language} onChange={handleLanguageChange} centered>
            <Tab label="中文" value="cn" />
            <Tab label="English" value="en" />
          </Tabs>
        </Box>
        
        {language === 'cn' ? (
          <>
            <Typography variant="body1" paragraph>
              最后更新日期：2024年3月21日
            </Typography>
            
            <Typography variant="body1" paragraph>
              Destiny Crystal（"我们"、"我们的"或"本公司"）尊重您的隐私，并致力于保护您的个人信息。本隐私政策旨在告知您我们如何收集、使用、披露、处理和保护您在使用我们的网站和服务时提供给我们的信息。
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              1. 我们收集的信息
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              我们可能收集以下类型的信息：
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="个人识别信息" 
                  secondary="包括姓名、电子邮件地址、电话号码、邮寄地址等。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="账户信息" 
                  secondary="包括您的用户名、密码、账户偏好设置等。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="交易信息" 
                  secondary="包括您的购买历史、支付详情、订单信息等。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="技术信息" 
                  secondary="包括IP地址、浏览器类型、设备信息、访问时间等。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="用户内容" 
                  secondary="包括您在使用我们的服务时提供的评论、反馈、信息等。" 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              2. 我们如何使用您的信息
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              我们可能将收集到的信息用于以下目的：
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="提供和改进我们的服务" 
                  secondary="包括处理订单、提供客户支持、改进网站体验等。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="个性化您的体验" 
                  secondary="根据您的偏好和历史记录提供定制化的内容和推荐。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="沟通与通知" 
                  secondary="向您发送订单确认、更新、营销信息和其他通知。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="分析和研究" 
                  secondary="了解用户行为和偏好，以改进我们的产品和服务。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="安全和欺诈防护" 
                  secondary="保护我们的网站、服务和用户免受欺诈和不当行为的侵害。" 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              3. 信息共享和披露
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              我们不会出售或出租您的个人信息给第三方用于营销目的。但在以下情况下，我们可能会共享您的信息：
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="服务提供商" 
                  secondary="与帮助我们运营网站、处理交易和提供服务的第三方服务提供商共享信息。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="业务转让" 
                  secondary="如果我们的业务或部分业务被出售或转让，您的信息可能会作为转让资产的一部分。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="法律要求" 
                  secondary="在法律要求、法院命令或政府请求的情况下披露信息。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="保护权益" 
                  secondary="当我们认为披露对于保护我们的权利、财产、安全或他人的权益是必要时。" 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              4. 数据安全
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              我们采取适当的物理、技术和管理措施来保护您的个人信息免遭未经授权的访问、使用或披露。这些措施包括但不限于：
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="加密技术" 
                  secondary="使用SSL加密保护数据传输，加密存储敏感信息。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="访问控制" 
                  secondary="限制员工访问个人数据，仅授权需要处理该信息的人员。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="安全审计" 
                  secondary="定期审查和更新我们的安全措施，确保适当保护。" 
                />
              </ListItem>
            </List>
            <Typography variant="body1" paragraph>
              虽然我们努力保护您的个人信息，但请注意，没有任何互联网传输或电子存储方法是100%安全的，我们不能保证绝对的安全性。
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              5. Cookie和类似技术
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              我们使用Cookie和类似技术（如网络信标、像素标签等）来收集和存储有关您如何使用我们网站的信息。这些技术帮助我们识别您、记住您的偏好、分析网站使用情况，以及提供个性化体验。
            </Typography>
            <Typography variant="body1" paragraph>
              您可以通过浏览器设置管理Cookie偏好，包括拒绝或删除Cookie。但请注意，禁用Cookie可能会影响网站的某些功能。
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              6. 您的权利和选择
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              根据适用的数据保护法律，您可能拥有以下权利：
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="访问权" 
                  secondary="请求访问我们持有的关于您的个人信息。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="更正权" 
                  secondary="更正我们持有的关于您的不准确或不完整的个人信息。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="删除权" 
                  secondary="在某些情况下，请求删除您的个人信息。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="反对权" 
                  secondary="反对我们处理您的个人信息，尤其是直接营销。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="限制处理权" 
                  secondary="要求我们限制对您个人信息的处理。" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="数据可携权" 
                  secondary="要求以结构化、常用和机器可读的格式接收您的个人信息。" 
                />
              </ListItem>
            </List>
            <Typography variant="body1" paragraph>
              要行使这些权利，请通过本政策末尾提供的联系方式与我们联系。
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              7. 儿童隐私
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              我们的服务不面向13岁以下的儿童。我们不会故意收集13岁以下儿童的个人信息。如果您是父母或监护人，并且您认为您的孩子向我们提供了个人信息，请联系我们，我们将删除这些信息。
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              8. 隐私政策更新
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              我们可能会不时更新本隐私政策。当我们进行重大变更时，我们将通过在网站上发布新的隐私政策来通知您，并在必要时通过电子邮件通知您。我们鼓励您定期查看本隐私政策以了解最新信息。
            </Typography>
            <Typography variant="body1" paragraph>
              继续使用我们的服务意味着您接受这些更改。
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              9. 联系我们
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              如果您对本隐私政策有任何疑问、意见或请求，请通过以下方式联系我们：
            </Typography>
            <Box sx={{ ml: 3 }}>
              <Typography variant="body1">电子邮件：dylan@martha-trade.com</Typography>
              <Typography variant="body1">地址：10 MARINA BOULEVARD #39 MARINA BAY FINANCIAL CENTRE SINGAPORE (018983)</Typography>
              <Typography variant="body1">电话：+65 91761341</Typography>
            </Box>
            
            <Box sx={{ mt: 6, p: 3, bgcolor: '#f8f5fb', borderRadius: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                通过使用我们的网站和服务，您确认您已阅读并理解本隐私政策。
              </Typography>
            </Box>
          </>
        ) : (
          <>
            <Typography variant="body1" paragraph>
              Last Updated: March 21, 2024
            </Typography>
            
            <Typography variant="body1" paragraph>
              Destiny Crystal ("we," "our," or "the Company") respects your privacy and is committed to protecting your personal information. This Privacy Policy is intended to inform you about how we collect, use, disclose, process, and protect the information you provide to us when using our website and services.
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              1. Information We Collect
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              We may collect the following types of information:
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="Personal Identification Information" 
                  secondary="Including name, email address, phone number, mailing address, etc." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Account Information" 
                  secondary="Including your username, password, account preferences, etc." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Transaction Information" 
                  secondary="Including your purchase history, payment details, order information, etc." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Technical Information" 
                  secondary="Including IP address, browser type, device information, access time, etc." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="User Content" 
                  secondary="Including comments, feedback, and information you provide when using our services." 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              2. How We Use Your Information
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              We may use the collected information for the following purposes:
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="Providing and Improving Our Services" 
                  secondary="Including processing orders, providing customer support, improving website experience, etc." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Personalizing Your Experience" 
                  secondary="Providing customized content and recommendations based on your preferences and history." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Communication and Notifications" 
                  secondary="Sending you order confirmations, updates, marketing information, and other notifications." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Analysis and Research" 
                  secondary="Understanding user behavior and preferences to improve our products and services." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Security and Fraud Protection" 
                  secondary="Protecting our website, services, and users from fraud and inappropriate behavior." 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              3. Information Sharing and Disclosure
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              We do not sell or rent your personal information to third parties for marketing purposes. However, we may share your information in the following situations:
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="Service Providers" 
                  secondary="Sharing information with third-party service providers who help us operate the website, process transactions, and provide services." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Business Transfer" 
                  secondary="If our business or part of our business is sold or transferred, your information may be part of the transferred assets." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Legal Requirements" 
                  secondary="Disclosing information when required by law, court order, or government request." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Protection of Rights" 
                  secondary="When we believe disclosure is necessary to protect our rights, property, safety, or the interests of others." 
                />
              </ListItem>
            </List>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              4. Data Security
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              We take appropriate physical, technical, and administrative measures to protect your personal information from unauthorized access, use, or disclosure. These measures include but are not limited to:
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="Encryption Technology" 
                  secondary="Using SSL encryption to protect data transmission and encrypting sensitive stored information." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Access Control" 
                  secondary="Limiting employee access to personal data, authorizing only personnel who need to process the information." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Security Audits" 
                  secondary="Regularly reviewing and updating our security measures to ensure appropriate protection." 
                />
              </ListItem>
            </List>
            <Typography variant="body1" paragraph>
              While we strive to protect your personal information, please note that no internet transmission or electronic storage method is 100% secure, and we cannot guarantee absolute security.
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              5. Cookies and Similar Technologies
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              We use cookies and similar technologies (such as web beacons, pixel tags, etc.) to collect and store information about how you use our website. These technologies help us identify you, remember your preferences, analyze website usage, and provide a personalized experience.
            </Typography>
            <Typography variant="body1" paragraph>
              You can manage cookie preferences through your browser settings, including rejecting or deleting cookies. However, please note that disabling cookies may affect certain website functions.
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              6. Your Rights and Choices
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              Under applicable data protection laws, you may have the following rights:
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="Right of Access" 
                  secondary="Request access to personal information we hold about you." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Right of Rectification" 
                  secondary="Correct inaccurate or incomplete personal information we hold about you." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Right of Erasure" 
                  secondary="Request deletion of your personal information in certain circumstances." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Right to Object" 
                  secondary="Object to our processing of your personal information, especially for direct marketing." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Right to Restrict Processing" 
                  secondary="Request that we limit the processing of your personal information." 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Right to Data Portability" 
                  secondary="Request to receive your personal information in a structured, commonly used, and machine-readable format." 
                />
              </ListItem>
            </List>
            <Typography variant="body1" paragraph>
              To exercise these rights, please contact us using the contact information provided at the end of this policy.
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              7. Children's Privacy
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              Our services are not directed at children under 13 years of age. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and believe your child has provided us with personal information, please contact us, and we will delete such information.
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              8. Privacy Policy Updates
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              We may update this Privacy Policy from time to time. When we make significant changes, we will notify you by posting the new Privacy Policy on the website and, when necessary, by email. We encourage you to review this Privacy Policy regularly to stay informed of the latest information.
            </Typography>
            <Typography variant="body1" paragraph>
              Continued use of our services means you accept these changes.
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              9. Contact Us
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              If you have any questions, comments, or requests regarding this Privacy Policy, please contact us through the following methods:
            </Typography>
            <Box sx={{ ml: 3 }}>
              <Typography variant="body1">Email: dylan@martha-trade.com</Typography>
              <Typography variant="body1">Address: 10 MARINA BOULEVARD #39 MARINA BAY FINANCIAL CENTRE SINGAPORE (018983)</Typography>
              <Typography variant="body1">Phone: +65 91761341</Typography>
            </Box>
            
            <Box sx={{ mt: 6, p: 3, bgcolor: '#f8f5fb', borderRadius: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                By using our website and services, you confirm that you have read and understand this Privacy Policy.
              </Typography>
            </Box>
          </>
        )}
      </Paper>
    </Container>
  );
};

export default Privacy;